import React from 'react';
import Table from '@/common/components/Table';
import { DetailSection, DetailTitle } from '../../callAnalysis.styles';
import {
	formatScore,
	getResultColor,
	getResultLabel,
} from '../../helpers/labels';

const HEADERS = ['Section', 'Weight', 'Score', 'Status'];

const SectionScoresSection = ({ sections }) => {
	if (!sections?.length) {
		return null;
	}

	const raws = sections.map((section) => (
		<tr key={section.section_id}>
			<td>{section.label || section.section_id}</td>
			<td>{section.weight}%</td>
			<td>{formatScore(section.score)}</td>
			<td style={{ color: getResultColor(section.result), fontWeight: 600 }}>
				{getResultLabel(section.result)}
			</td>
		</tr>
	));

	return (
		<DetailSection>
			<DetailTitle>Section scores</DetailTitle>
			<Table className='styled-table' headers={HEADERS} raws={raws} />
		</DetailSection>
	);
};

export default SectionScoresSection;
